type NotationPitch = {
  halfTone?: number;
  isRest?: () => boolean;
  Pitch?: {
    getHalfTone?: () => number;
    Octave?: number;
    FundamentalNote?: number;
    AccidentalHalfTones?: number;
  };
};

/** OSMD halfTone is MIDI minus 12; its internal octaves are MusicXML minus 3. */
export function notationNoteToMidi(note?: NotationPitch): number | null {
  if (!note || note.isRest?.()) return null;
  if (typeof note.halfTone === 'number' && Number.isFinite(note.halfTone))
    return Math.round(note.halfTone + 12);
  const pitch = note.Pitch;
  const halfTone = pitch?.getHalfTone?.();
  if (typeof halfTone === 'number' && Number.isFinite(halfTone)) return Math.round(halfTone + 12);
  if (typeof pitch?.Octave !== 'number' || typeof pitch.FundamentalNote !== 'number') return null;
  return Math.round(
    (pitch.Octave + 4) * 12 + pitch.FundamentalNote + (pitch.AccidentalHalfTones ?? 0),
  );
}
